import React from 'react';
import { Check, ArrowRight, Users, Clock, Video, Monitor, Wifi, Zap } from 'lucide-react';
import { PageTransition } from '../../components/layout/PageTransition';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { DecorativeShape } from '../../components/DecorativeShape';
import { Animate } from '../../components/ui/Animate';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
export function BetterOnlineMeetings() {
  const {
    t
  } = useLanguage();
  const benefits = t('betterOnlineMeetings.benefits') as string[];
  const sessions = t('betterOnlineMeetings.sessions') as Array<{
    title: string;
    desc: string;
    topicsLabel: string;
    topics: string[];
  }>;
  const forWhomItems = t('betterOnlineMeetings.forWhomItems') as string[];
  const forWhomIcons = [<Monitor className="text-blue-600 shrink-0" size={20} data-id="element-475" data-mp="3q3bq643cco73" />, <Zap className="text-blue-600 shrink-0" size={20} data-id="element-476" data-mp="3q4wng1h1il8n" />, <Users className="text-blue-600 shrink-0" size={20} data-id="element-477" data-mp="1x6pm9bugmbkl" />];
  return <PageTransition data-id="element-478" data-mp="224rf2ohotp99">
      <div className="pt-12 pb-24" data-id="element-479" data-mp="2247x57s1f0v8">
        <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-480" data-mp="225am3a5sut8i">
          <DecorativeShape type="circle" color="bg-blue-100" className="top-0 right-0 w-[400px] h-[400px] translate-x-1/4 -translate-y-1/4 -z-10" data-id="element-481" data-mp="273c6pzivj0m3" />
          <DecorativeShape type="blob" color="bg-indigo-100" className="bottom-0 left-0 w-64 h-64 -translate-x-1/4 translate-y-1/4 -z-10" data-id="element-482" data-mp="2fvmdt7yh2pz4" />
          <Animate className="text-center max-w-4xl mx-auto" data-id="element-483" data-mp="2pvn278b77wa6">
            <span className="inline-block px-4 py-2 bg-blue-50 text-blue-600 font-medium rounded-full text-sm mb-6" data-id="element-484" data-mp="2utoixml5jjih">
              {t('betterOnlineMeetings.badge')}
            </span>
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-485" data-mp="vindmpoubrqr">
              {t('betterOnlineMeetings.title')} <br data-id="element-486" data-mp="sezjn6opo4pz" />
              <span className="text-blue-600" data-id="element-487" data-mp="seg05ljex89u">
                {t('betterOnlineMeetings.titleHighlight')}
              </span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-488" data-mp="nhfw1g64ifld">
              {t('betterOnlineMeetings.subtitle')}
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-gray-500 mb-10" data-id="element-489" data-mp="xe2fc0iswyla">
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-490" data-mp="1bdk6unnhepyc">
                <Clock size={18} className="text-blue-600" data-id="element-491" data-mp="16fik9squk8i4" />
                <span data-id="element-492" data-mp="1l3n8fc8o5c8a">{t('betterOnlineMeetings.duration')}</span>
              </div>
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-493" data-mp="1l5pu5k2sgj77">
                <Video size={18} className="text-blue-600" data-id="element-494" data-mp="1u4bdvijzy49k" />
                <span data-id="element-495" data-mp="1u4l333x7w7e7">{t('betterOnlineMeetings.audience')}</span>
              </div>
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-496" data-mp="1q413zut32tpf">
                <Wifi size={18} className="text-blue-600" data-id="element-497" data-mp="28rtm2qwrph0q" />
                <span data-id="element-498" data-mp="2dp23gpa3dh0x">{t('betterOnlineMeetings.online')}</span>
              </div>
            </div>
            <Link to="/contact" data-id="element-499" data-mp="1zpai23h8wycw">
              <Button className="bg-blue-600 hover:bg-blue-700 text-white shadow-blue-200" size="lg" rightIcon={<ArrowRight size={20} data-id="element-501" data-mp="1q00qcoqbdhpb" />} data-id="element-500" data-mp="1zq2fzkybf86c">
                {t('betterOnlineMeetings.bookCta')}
              </Button>
            </Link>
          </Animate>
        </section>

        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-24" data-id="element-502" data-mp="1gzud93yj2jqo">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-503" data-mp="1gxri65iiq0f3">
            <div className="lg:col-span-2 space-y-12" data-id="element-504" data-mp="1l290s1d567oa">
              <Animate data-id="element-505" data-mp="171y6spgjccyw">
                <h2 className="text-3xl font-bold mb-6 text-charcoal" data-id="element-506" data-mp="171eoh7mz3mkc">
                  {t('betterOnlineMeetings.aboutTitle')}
                </h2>
                <div className="prose prose-lg text-gray-600" data-id="element-507" data-mp="1c2u76t1ohgzk">
                  <p className="mb-4" data-id="element-508" data-mp="2ecvxocl6ow3a">{t('betterOnlineMeetings.aboutP1')}</p>
                  <p data-id="element-509" data-mp="2acc0j90m1sh5">{t('betterOnlineMeetings.aboutP2')}</p>
                </div>
              </Animate>
              <Animate delay={0.1} data-id="element-510" data-mp="25l2boamvyt6b">
                <h3 className="text-2xl font-bold mb-6 text-charcoal" data-id="element-511" data-mp="25k126aliqeqp">
                  {t('betterOnlineMeetings.learnTitle')}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-512" data-mp="1vo7fvzhzz6vq">
                  {benefits.map((benefit: string, index: number) => <div key={index} className="flex items-start gap-3" data-id="element-513" data-mp="1qn1oq63zjrob" data-mpi={index}>
                      <div className="mt-1 p-1 rounded-full bg-blue-50 text-blue-600 flex-shrink-0" data-id="element-514" data-mp="1mo14cj5v0gz7">
                        <Check size={14} strokeWidth={3} data-id="element-515" data-mp="1hoybdx35m17l" />
                      </div>
                      <span className="text-gray-700" data-id="element-516" data-mp="3h1akuuwtp2qy">{benefit}</span>
                    </div>)}
                </div>
              </Animate>
              <Animate delay={0.15} data-id="element-517" data-mp="3c03couqrq1jr">
                <h3 className="text-2xl font-bold mb-6 text-charcoal" data-id="element-518" data-mp="3jm8jmb77mmwq">
                  {t('betterOnlineMeetings.structureTitle')}
                </h3>
                <div className="space-y-6" data-id="element-519" data-mp="3oigrr4mzpfue">
                  {sessions.map((session, index) => <Card key={index} className="p-6 border-l-4 border-blue-600 bg-white" data-id="element-520" data-mp="3tdcv30xofpmt" data-mpi={index}>
                      <h4 className="text-xl font-bold text-charcoal mb-2" data-id="element-521" data-mp="30nmgyrw1onqp">
                        {session.title}
                      </h4>
                      <p className="text-gray-600 mb-4" data-id="element-522" data-mp="35nimivke4n8d">{session.desc}</p>
                      <div className="bg-blue-50 p-4 rounded-xl" data-id="element-523" data-mp="3aj7f2exzt3v6">
                        <p className="text-sm font-bold text-blue-800 mb-2" data-id="element-524" data-mp="3emm4fw7tmwla">
                          {session.topicsLabel}
                        </p>
                        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-525" data-mp="pwme5r0k3s6c">
                          {session.topics.map((topic: string, i: number) => <li key={i} className="flex items-center gap-2 text-sm text-gray-700" data-id="element-526" data-mp="2qvpseptcjieo" data-mpi={i}>
                              <div className="w-1.5 h-1.5 rounded-full bg-blue-600" data-id="element-527" data-mp="2zxpbdnnx8wk9" />
                              {topic}
                            </li>)}
                        </ul>
                      </div>
                    </Card>)}
                </div>
              </Animate>
            </div>
            <div className="lg:col-span-1" data-id="element-528" data-mp="2353pte242qc2">
              <div className="sticky top-24 space-y-8" data-id="element-529" data-mp="2gyuxsi07225o">
                <Card className="p-8 bg-white shadow-xl border-t-4 border-blue-600" data-id="element-530" data-mp="2h0ftiay8vr54">
                  <h3 className="text-xl font-bold mb-6 text-charcoal" data-id="element-531" data-mp="2c6jzfjl3qof8">
                    {t('betterOnlineMeetings.forWhom')}
                  </h3>
                  <ul className="space-y-4 mb-8" data-id="element-532" data-mp="1jjqs2id7iqw9">
                    {forWhomItems.map((item: string, i: number) => <li key={i} className="flex items-start gap-3" data-id="element-533" data-mp="3v5rc1023uexl" data-mpi={i}>
                        {forWhomIcons[i]}
                        <span className="text-gray-600" data-id="element-534" data-mp="3tg5q9chjdmx">{item}</span>
                      </li>)}
                  </ul>
                  <Link to="/contact" className="block" data-id="element-535" data-mp="3r4z3k9124e2d">
                    <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white shadow-blue-200" rightIcon={<ArrowRight size={18} data-id="element-537" data-mp="mqr3fpigxz09" />} data-id="element-536" data-mp="3r5h4hiynzggm">
                      {t('betterOnlineMeetings.inquiry')}
                    </Button>
                  </Link>
                </Card>
                <div className="bg-blue-50 rounded-3xl p-8 text-center" data-id="element-538" data-mp="dq2peut2rynd">
                  <div className="w-16 h-16 mx-auto bg-white rounded-full flex items-center justify-center shadow-md mb-4 text-blue-600" data-id="element-539" data-mp="ds5py8ruta6c">
                    <Video size={32} data-id="element-540" data-mp="2ygtfbcaso6xs" />
                  </div>
                  <h4 className="font-bold text-lg mb-2" data-id="element-541" data-mp="2ye7ahkfag5j9">
                    {t('betterOnlineMeetings.privateTitle')}
                  </h4>
                  <p className="text-gray-600 text-sm mb-4" data-id="element-542" data-mp="3l48rpta5yjhd">
                    {t('betterOnlineMeetings.privateDesc')}
                  </p>
                  <Link to="/contact" className="text-blue-600 font-bold hover:underline" data-id="element-543" data-mp="3g5xinkrp0d07">
                    {t('betterOnlineMeetings.contactLink')}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="max-w-4xl mx-auto px-4 text-center" data-id="element-544" data-mp="7s84vkjixuhu">
          <Animate data-id="element-545" data-mp="2xkpqcaeucfx">
            <Card className="p-12 bg-gradient-to-br from-blue-50 to-indigo-50 border-0" data-id="element-546" data-mp="2x2i6jiasbsp">
              <h2 className="text-3xl font-bold mb-4" data-id="element-547" data-mp="3u56nxped1mpe">
                {t('betterOnlineMeetings.ctaTitle')}
              </h2>
              <p className="text-gray-600 mb-8 max-w-xl mx-auto" data-id="element-548" data-mp="qoq56qcfv2pp">
                {t('betterOnlineMeetings.ctaDesc')}
              </p>
              <Link to="/contact" data-id="element-549" data-mp="yyfdkj1o2bu2">
                <Button className="bg-blue-600 hover:bg-blue-700 text-white shadow-blue-200" rightIcon={<ArrowRight size={18} data-id="element-551" data-mp="17y22w6h4fr6r" />} data-id="element-550" data-mp="yz6zt39dix7o">
                  {t('betterOnlineMeetings.ctaCta')}
                </Button>
              </Link>
            </Card>
          </Animate>
        </section>
      </div>
    </PageTransition>;
}